module.exports = __webpack_public_path__ + "img/Notes.10e3425a.svg";